const NotFound = () => {
  return (
    <section>
      <h2>Not Found!</h2>
      <em style={{color: 'red'}}>Oops, did you forgot something?</em>

      <p><a href="/">Go back home</a></p>
    </section>
  )
};

export default NotFound;